var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from 'react';
import { useNotify, useRedirect } from 'react-admin';
import { useDeleteBranch } from '../dataProvider';
/**
 * Prepare callback for a delete branch button with undo support
 *
 * @example
 *
 * import React from 'react';
 * import ActionDelete from '@material-ui/icons/Delete';
 * import { Button, useDeleteBranchWithUndoController } from '@react-admin/ra-tree';
 *
 * const DeleteButton = ({
 *     resource,
 *     record,
 *     basePath,
 *     redirect,
 *     onClick,
 *     ...rest
 * }) => {
 *     const [handleDelete, { isLoading }] = useDeleteBranchWithUndoController({
 *         resource,
 *         record,
 *         redirect,
 *     });
 *
 *     const handleClick = () => {
 *         handleDelete();
 *     }
 *
 *     return (
 *         <Button
 *             onClick={handleClick}
 *             disabled={isLoading}
 *             label="ra.action.delete"
 *             {...rest}
 *         >
 *             <ActionDelete />
 *         </Button>
 *     );
 * };
 */
export var useDeleteBranchWithUndoController = function (_a) {
    var mutationOptions = _a.mutationOptions, record = _a.record, _b = _a.redirect, redirectTo = _b === void 0 ? 'list' : _b, resource = _a.resource;
    var notify = useNotify();
    var redirect = useRedirect();
    var _c = useDeleteBranch(), deleteBranch = _c[0], isLoading = _c[1].isLoading;
    var handleDelete = useCallback(function (event) {
        event.stopPropagation();
        deleteBranch(resource, {
            id: record.id,
            previousData: record,
        }, __assign({ onSuccess: function () {
                notify('ra.notification.deleted', {
                    type: 'info',
                    messageArgs: { smart_count: 1 },
                    undoable: true,
                });
                redirect(redirectTo, resource);
            }, onError: function (error) {
                return notify(typeof error === 'string'
                    ? error
                    : error.message || 'ra.notification.http_error', { type: 'warning' });
            }, mutationMode: 'undoable' }, mutationOptions));
    }, [
        deleteBranch,
        mutationOptions,
        notify,
        record,
        redirect,
        redirectTo,
        resource,
    ]);
    return { handleDelete: handleDelete, isLoading: isLoading };
};
